// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateExcessContributionFormResponseDto
 */
export interface ICreateExcessContributionFormResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormResponseDto
     */
    excess_contribution_id?: number;
}

/**
 * Check if a given object implements the ICreateExcessContributionFormResponseDto interface.
 */
export function instanceOfICreateExcessContributionFormResponseDto(value: object): value is ICreateExcessContributionFormResponseDto {
    return true;
}

export function ICreateExcessContributionFormResponseDtoFromJSON(json: any): ICreateExcessContributionFormResponseDto {
    return ICreateExcessContributionFormResponseDtoFromJSONTyped(json, false);
}

export function ICreateExcessContributionFormResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateExcessContributionFormResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'excess_contribution_id': json['excess_contribution_id'] == null ? undefined : json['excess_contribution_id'],
    };
}

export function ICreateExcessContributionFormResponseDtoToJSON(json: any): ICreateExcessContributionFormResponseDto {
    return ICreateExcessContributionFormResponseDtoToJSONTyped(json, false);
}

export function ICreateExcessContributionFormResponseDtoToJSONTyped(value?: ICreateExcessContributionFormResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'excess_contribution_id': value['excess_contribution_id'],
    };
}

